var map = {
	"./account.svg": "9234",
	"./create_user.svg": "6c7b",
	"./delivery_days.svg": "2950",
	"./edit_user.svg": "ed2c",
	"./imprint.svg": "d5f6",
	"./inventory.svg": "015f",
	"./inventory_days.svg": "d9ec",
	"./logout.svg": "bc57",
	"./news.svg": "5331",
	"./orders.svg": "7d80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9e5";